// extracted by mini-css-extract-plugin
export var fadeInAnimation = "ModalStep-module--fadeInAnimation--0db1f";
export var scrollArea = "ModalStep-module--scrollArea--16fb4";
export var stepWrapper = "ModalStep-module--stepWrapper--df889";
export var title = "ModalStep-module--title--7a9f9";